// Najveci popust koji se smije dati na artikl.
//
// Popust se racuna od prodajne cijene BEZ PDV-a, a smije ici najvise do marze:
// ispod nabavne cijene se ne prodaje. Zato je gornja granica onaj postotak
// prodajne cijene koji je marza:
//
//   marza u novcu = prodajna bez PDV-a - nabavna s popustom
//   max popust %  = marza u novcu / (prodajna bez PDV-a / 100)
//
// Nema marze (ili je negativna) -> nema sto popustiti, max popust je 0 %.
//
// Prije se na nekoliko mjesta dijelio POSTOTAK marze s NOVCANIM iznosom jednog
// posto cijene, pa su ispadali brojevi poput 100,04 % ili 519 %. Zbog toga je
// izracun sad na jednom mjestu, da se vise ne moze razici.

const broj = (vrijednost) => parseFloat(vrijednost) || 0

const maxPopust = (prodajnaBezPdv, nabavnaSPopustom) => {
  const prodajna = broj(prodajnaBezPdv)
  const nabavna = broj(nabavnaSPopustom)
  if (prodajna <= 0) { return 0 }
  const marzaNovcano = prodajna - nabavna
  if (marzaNovcano <= 0) { return 0 }
  // Popust od 100 % je cijela cijena - vise od toga nema smisla. Preko toga se
  // ide samo kad je nabavna negativna (npr. popust dobavljaca veci od 100 %).
  const postotak = Math.round((marzaNovcano / (prodajna / 100)) * 100) / 100
  return postotak > 100 ? 100 : postotak
}

export default maxPopust
